import { gql } from '@apollo/client';

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($pass: String, $id: ID!) {
    updateUsersPermissionsUser(id: $id, data: { mdp: $pass }) {
      data {
        id
      }
    }
  }
`;
